<template>
  <div class="user-scope-tree-user-list">
    <div class="_heading">
      <h5>
        {{ $t('userScopeTreeUserList.userList') }} ({{ count }})
      </h5>
      <m-spinner
        v-if="loading"
        class="_spinner"
        size="xs"
      />
    </div>
    <div class="_list">
      <transition
        mode="out-in"
        name="list-left"
      >
        <div
          :key="page"
        >
          <m-card-item
            v-for="user in userList"
            :key="user.uid"
            no-hover
            :clickable="false"
          >
            <user-display :user="user" />
          </m-card-item>
        </div>
      </transition>
    </div>
    <div
      v-if="count > itemsPerPage"
      class="_pagination"
    >
      <m-pagination
        v-model:value="page"
        :total="count"
        :items-per-page="itemsPerPage"
        small
        hide-border
      />
    </div>
  </div>
</template>

<script>
import UserDisplay from 'shared/components/UserDisplay.vue';
import useDebounce from '@/composables/debounce';
import { COUNT, RESULT } from 'shared/api/query/constants';
import { dogma } from '@/api';
import { userListByScopeTree } from '@/api/query/user';

export default {
  name: 'UserScopeTreeUserList',
  props: {
    userScopeTree: {
      validator: (prop) => typeof prop === 'object',
      required: true,
    },
  },
  emits: ['update-count'],
  components: { UserDisplay },
  setup() {
    const { debounce } = useDebounce();
    return { debounce };
  },
  data() {
    return {
      userList: [],
      count: 0,
      loading: false,
      itemsPerPage: 10,
      page: 1,
    };
  },
  methods: {
    retrieveUserList() {
      const getUsers = () => {
        this.loading = true;
        const pagination = {
          page: this.page,
          itemsPerPage: this.itemsPerPage,
          countAlias: COUNT,
        };
        dogma.query(userListByScopeTree(this.userScopeTree, pagination)).then((response) => {
          this.loading = false;
          this.userList = response.data[RESULT];
          this.count = response.data[COUNT][0][COUNT];
          this.$emit('update-count', this.count);
        });
      };

      this.debounce(getUsers, 500);
    },
  },
  watch: {
    userScopeTree: {
      handler(val, oldVal) {
        if (JSON.stringify(val) === JSON.stringify(oldVal)) {
          return;
        }
        this.retrieveUserList();
      },
      deep: true,
    },
    page() {
      this.retrieveUserList();
    },
  },
  created() {
    this.retrieveUserList();
  },
};
</script>

<style scoped lang="scss" type="text/scss">

  .user-scope-tree-user-list {
    ._heading {
      display: flex;

      ._spinner {
        margin-left: 1rem;
      }
    }

    ._pagination {
      display: flex;
      justify-content: center;
      margin-top: 1rem;
    }
  }
</style>
